<template>
    <div>
        <Header />
        <router-view :key="$route.fullPath" />
        <Toaster position="top-right" rich-colors expand />
        <Footer />
    </div>
</template>

<script setup>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
</script>
